export const DEFAULT_CONFIGS = {
    "seo": {
        "categories": {
            "images": {
                "alt": "SEO_IMAGE_CATEGORIES_ALT",
                "title": "SEO_IMAGE_CATEGORIES_TITLE"
            }
        },
        "games": {
            "images": {
                "alt": "SEO_IMAGE_GAME_TITLE"
            }
        }
    },
    "adminBanner": {
        "enabled": false
    },
    "SDK": {
        "debug": false,
        "Integration": {
            "races": {
                "racesPageURL": "/races/#tabID={tabID}"
            },
            "historyLink": "/gaming-history/",
            "gameSessionHistoryLink": "/session-history/",
            "legalInfoLink": "/security-and-privacy/license/"
        },
        "Analytics": {
            "GTMContainerID": "GTM-NTXB7CN",
            "UATrackingID": "UA-66227773-1",
            "awaitForDataLayer": "true"
        }
    },
    "generalSettings": {
        "showRegisterButton": true,
        "gamesSettings":{
            "gamesCategories": {
                "slots": [
                    "VideoSlot",
                    "Scratch Card",
                    "Slot"
                ],
                "cardAndTable": [
                    "Blackjack",
                    "Roulette",
                    "Craps",
                    "Baccarat",
                    "Keno",
                    "VideoPoker",
                    "Caribbean Poker",
                    "Poker table games",
                    "Roulette like",
                    "Arcade"
                ],
                "live": [
                    "Live Casino"
                ]
            }
        },
        "gamesPreviewConfig": {
            "enabledOnPC": false,
            "shouldDisplayJackpot": true,
        }
    },
    "miniOrbit": {
        "/cip": {
            "arenasHeaderButtons": [
                {
                    "title": "LOBBY",
                    "link": "/cip",
                    "icon": "{assetsPath}/images/mini_orbit/cip/arenas_header_buttons/my_casino_icon.png",
                },
                {
                    "title": "SLOTS",
                    "link": "/cip/slots",
                    "icon": "{assetsPath}/images/mini_orbit/cip/arenas_header_buttons/slots_icon.png",
                },
                {
                    "title": "JACKPOTS",
                    "link": "/cip/jackpots",
                    "icon": "{assetsPath}/images/mini_orbit/cip/arenas_header_buttons/jackpots_icon.png"
                },
                {
                    "title": "LIVE_CASINO",
                    "link": "/cip/live-casino",
                    "icon": "{assetsPath}/images/mini_orbit/cip/arenas_header_buttons/live_icon.png"
                },
                {
                    "title": "CASINO_GAMES",
                    "link": "/cip/casino-games",
                    "icon": "{assetsPath}/images/mini_orbit/cip/arenas_header_buttons/casino_games_icon.png"
                }
            ]
        },
        "/cis": {
            "arenasHeaderButtons": [
                {
                    "title": "LOBBY",
                    "link": "/cis",
                    "icon": "{assetsPath}/images/mini_orbit/cis/arenas_header_buttons/my_casino_icon.png",
                },
                {
                    "title": "SLOTS",
                    "link": "/cis/slots",
                    "icon": "{assetsPath}/images/mini_orbit/cis/arenas_header_buttons/slots_icon.png",
                },
                {
                    "title": "CASINO_GAMES",
                    "link": "/cis/casino-games",
                    "icon": "{assetsPath}/images/mini_orbit/cis/arenas_header_buttons/casino_games_icon.png"
                },
                {
                    "title": "LIVE_CASINO",
                    "link": "/cis/live-casino",
                    "icon": "{assetsPath}/images/mini_orbit/cis/arenas_header_buttons/live_icon.png"
                },
                {
                    "title": "JACKPOTS",
                    "link": "/cis/jackpots",
                    "icon": "{assetsPath}/images/mini_orbit/cis/arenas_header_buttons/jackpots_icon.png"
                }
            ]
        }
    },
    "theme": {
        "name": "casino888"
    }

};
